/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { MPlugins } from 'js/entry/util.js';
import { $ } from 'js/entry/base.js';
import { mjt } from 'js/entry/i18ntexts.js';
import { MVMediaPage } from 'js/entry/media.js';
import { getApproverVotesCombinedState, setApproverVotesValue } from './approver_votes.js';


function applyVotesToResultView( voting_id, $result_elem, object_item, av_changed_dt, av_submitted_dt, approver_votes, media_ids, call_plugins ) {
	// cleanup
	$result_elem.find('.x-votings').removeClass('x-votings x-votings-in x-votings-out');
	$result_elem.find('.mm-votings').remove();

	// apply
	for( const media_id in approver_votes ) {
		if( !approver_votes.hasOwnProperty(media_id) ) continue;
		const vote_value = approver_votes[media_id];
		const $media_item = $result_elem.find('div[data-mj_mid='+media_id+']');
		if( $media_item.length ) {
			const $media_menu = $media_item.find('.media_menu');
			if( vote_value ) {
				$media_item.addClass('x-votings x-votings-in');
				if( $media_menu.length ) $media_menu.append('<div class="mmb mm-votings mm-votings-in" title="'+mjt('ctx-menu-votings-approved')+'"></div>');
			} else {
				$media_item.addClass('x-votings x-votings-out');
				if( $media_menu.length ) $media_menu.append('<div class="mmb mm-votings mm-votings-out" title="'+mjt('ctx-menu-votings-rejected')+'"></div>');
			}
		}
	}

	if( call_plugins ) {
		MPlugins.callOnAllPluginsOfType('MediaResultInfoView','afterApplyApproversVotesToResultView',true,voting_id,object_item,av_changed_dt,av_submitted_dt,approver_votes,media_ids);
	}
}



function applyVotesToCtxToolbarExtraElem( $extraElem, approver_votes, sel_media_ids ) {
	var $both = $('#media-ctxtb-votings-approve,#media-ctxtb-votings-reject',$extraElem).removeClass('partial checked');
	var combinedState = getApproverVotesCombinedState(approver_votes,sel_media_ids);
	if( combinedState===true ) {
		// all true
		$('#media-ctxtb-votings-approve',$extraElem).addClass('checked');
	} else if( combinedState===false ) {
		// all false
		$('#media-ctxtb-votings-reject',$extraElem).addClass('checked');
	} else if( combinedState===undefined ) {
		// undefined yet
	} else {
		// half/half
		$both.addClass('partial');
	}
}

export function onApproverResultViewNodesLoaded( $result_elem, object_id, object_item, av_changed_dt, av_submitted_dt, approver_votes, media_ids, loaded_media_ids ) {
	const voting_id = object_item.x_id || 0;
	applyVotesToResultView(voting_id,$result_elem,object_item,av_changed_dt,av_submitted_dt,approver_votes,media_ids,false);
}



var m_last_voting_id = null;
var m_last_approver_votes_changed_dt = null;
var m_last_rv_change_count = 0;

export function onApproverResultViewSelectionChanged( $result_elem, object_id, object_item, av_changed_dt, av_submitted_dt, approver_votes, media_ids, sel_media_ids ) {
	const voting_id = object_item.x_id || 0;

	var ui_states = {
		voting_changed: false,
		result_view_changed: false,
	};

	if( m_last_voting_id!==voting_id ) {
		ui_states.voting_changed = true;
		if( m_last_approver_votes_changed_dt!==av_changed_dt ) {
			ui_states.voting_changed = true;
		}
		m_last_approver_votes_changed_dt = av_changed_dt;
		m_last_voting_id = voting_id;
	}

	const rv_widget = $result_elem.data('mjMjMediaResultViewWidget');

	const rv_change_count = rv_widget.getChangeCount();
	if( m_last_rv_change_count!==rv_change_count ) {
		ui_states.result_view_changed = true;
		m_last_rv_change_count = rv_change_count;
	}


	if( ui_states.voting_changed || ui_states.result_view_changed ) applyVotesToResultView(voting_id,$result_elem,object_item,av_changed_dt,av_submitted_dt,approver_votes,media_ids,true);


	// controls for approvers to cast their votes
	const $approverVotes_extraElem = $(
		'<li id="ctx-toolbar-votings" class="submenu media-ctx-menu-votings-section"><span class="icon icon-approve icon-coloured"></span>'+mjt('ctx-menu-votings')+
			'<ul>'+
				'<li id="media-ctxtb-votings-approve" class="has-border media-ctxtb-votings-action"><span class="state">&nbsp;</span><span class="text">'+mjt('ctx-menu-votings-approve-action')+'</span></li>'+
				'<li id="media-ctxtb-votings-reject" class="has-border media-ctxtb-votings-action"><span class="state">&nbsp;</span><span class="text">'+mjt('ctx-menu-votings-reject-action')+'</span></li>' +
			'</ul>'+
		'</li>'
	);

	applyVotesToCtxToolbarExtraElem($approverVotes_extraElem,approver_votes,sel_media_ids);

	if( av_submitted_dt!=null ) {
		// disable approve & reject actions ..
		$approverVotes_extraElem.find('#media-ctxtb-votings-approve,#media-ctxtb-votings-reject').addClass('disabled');
		MVMediaPage.contextMenuDynamicContent({'html': [$approverVotes_extraElem]});
	} else {
		// bind handlers for approve & reject actions ..
		const setApproverVotesValue_done = function( res_av_changed_dt, res_av_submitted_dt, res_approver_votes ) {
			applyVotesToResultView(voting_id,$result_elem,object_item,res_av_changed_dt,res_av_submitted_dt,res_approver_votes,media_ids,true);
			applyVotesToCtxToolbarExtraElem($approverVotes_extraElem,res_approver_votes,sel_media_ids);
		};
		let ctx_menu_additions = {
			'bindings': {
				'media-ctxtb-votings-approve': function(e) {
					const checked = $(e.currentTarget).hasClass('checked');
					const vote_value = checked ? null : true;
					setApproverVotesValue( voting_id, sel_media_ids, vote_value, setApproverVotesValue_done );
				},
				'media-ctxtb-votings-reject': function(e) {
					const checked = $(e.currentTarget).hasClass('checked');
					const vote_value = checked ? null : false;
					setApproverVotesValue( voting_id, sel_media_ids, vote_value, setApproverVotesValue_done );
				}
			},
			'html': [$approverVotes_extraElem]
		};
		MVMediaPage.contextMenuDynamicContent(ctx_menu_additions);
	}
}
